module.exports = __webpack_public_path__ + "img/disabledPersons.c0e3508c.png";